const de = {
  noOffers: 'Leider haben Sie derzeit keine offenen Stellenangebote',
  openOffers: 'Offene Stellen',
  forbidden: 'Sie können nur Ihr eigenes Firmenprofil ansehen.',
  notActive: 'Ihre Firma ist gerade nicht freigeschaltet und kann nicht bearbeitet werden.',
  banCompany: {
    title: '{{name}} bannen',
    description:
      'Sie sind im Begriff diese Firma zu bannen. Bitte geben Sie hier ihre Beweggründe ein. Diese Information wird der Firma mitgeteilt.'
  },
  notAvailable: 'Diese Firma ist zur Zeit nicht verfügbar',
  openFailed: 'Firma konnte nicht geöffnet werden',
  notFound: 'Firma konnte nicht gefunden werden',
  errorLoading: 'Firma konnte nicht geladen werden.',
  missingFields: {
    country: 'Land',
    invoiceEmail: 'Rechnungsemail',
    taxIdAndNumber: 'Ust-IdNr. und Steuernummer'
  },
  offerWarning: {
    title: 'Unvollständiges Firmenprofil',
    description: 'Die Daten in Ihrem Firmenprofil sind leider unvollständig.',
    emptyFields: 'Folgende Felder müssen ausgefüllt werden:',
    explanation: 'Daher können Sie keine kostenpflichtigen Inserate erstellen.',
    editCompanyButton: 'Firma bearbeiten',
    createOfferButton: 'Trotzdem weiter'
  }
};
export default de;
export type MyOffersTranslation = typeof de;
